import { unsafelyEntries } from "common/utilities/object";
import type { KnowledgeFeedFetchForTopicPayload } from "entities/knowledgeFeed/actionTypes";

export const getLatestFetchParams = (params: KnowledgeFeedFetchForTopicPayload) =>
  unsafelyEntries(params).reduce<Record<string, string | number | undefined>>(
    (accumulator, [key, value]) => ({
      ...accumulator,
      ...(key !== "id" && value !== "" && { [keyLookup[key] ?? key]: value }),
    }),
    {},
  );

const keyLookup: Record<string, string | undefined> = {
  content_type: "content_type",
  fromTime: "from_time",
  publication_type: "publication_type",
  search: "search",
  toTime: "to_time",
};
